<div class="container">
  <button mat-stroked-button routerLink="">
    <mat-icon fontIcon="arrow_back"/>
    Return to Dashboard
  </button>
  <h1>Build Info</h1>
  <mat-form-field appearance="outline" style="width: 250px">
    <mat-label>Date</mat-label>
    <input matInput [value]="buildDate" readonly>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Hash</mat-label>
    <input matInput [value]="buildHash" readonly>
  </mat-form-field>
  <h1>Device Info</h1>
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>UserAgent</mat-label>
    <input matInput [value]="userAgent" readonly>
  </mat-form-field>
  <!-- <button mat-stroked-button *ngIf="!isTesla()" style="display: block; margin-bottom: 16px" (click)="reportDetectionIssue()">Report Tesla Detection Issue</button>
  <mat-form-field appearance="outline" *ngIf="isTesla()">
    <mat-label>Tesla Firmware</mat-label>
    <input matInput [value]="getTeslaFirmware()" readonly>
  </mat-form-field> -->
  <mat-form-field appearance="outline">
    <mat-label>Viewport Width</mat-label>
    <input matInput [value]="getViewport(true)" readonly>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Viewport Height</mat-label>
    <input matInput [value]="getViewport(false)" readonly>
  </mat-form-field>
</div>